<template>
  <div class="study">
    <div class="banner">
      <img src="@/assets/person/dp-gr-xx1.png" alt />
    </div>
    <div class="class-box">
      <div class="class-template" v-for="four in fours" :key="four.imgUrl" @click="goVedio(four)">
        <img :src="four.VideoImage" alt />
        <p v-text="four.VideoTitle"></p>
        <p v-text="four.VideoTime"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fours: [
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy16.png"),
          title: "平“语”近人",
          source: "共产党员网·2018.02.03"
        },
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy17.png"),
          title: "听学新思想",
          source: "共产党员网·2018.02.03"
        }
      ]
    };
  },
  methods: {
   goVedio(sourceLink) {    
    //  console.log(sourceLink);
     
      this.$router.push({
        path: "/boutique/videoPlayer",
        query: { title: "视频播放", source: JSON.stringify(sourceLink) }
      });
    },
    getMsg() {
      this.axios.get("/api/Personal/Study?title="+'聚焦十九大（由中组部党员教育和干部测评中心承办）').then(e => {
        switch (e.data.code) {
          case 0:
            // console.log(e.data.code);
            
            this.fours = e.data.msg
            break;
        
          default:
            break;
        }
      });
    }
  },
  mounted() {
    this.getMsg();
  }
};
</script>
<style lang='scss' scoped>
.study {
  .class-box {
    .class-template {
      &:nth-child(odd) {
        margin-right: 2%;
      }
      img {
        width: 100%;
      }
      p {
        &:nth-child(2) {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
        }
        &:nth-child(3) {
          color: #999999;
          font-size: 0.26rem;
        }
        line-height: 2;
        padding: 0 0.2rem;
      }
      width: 49%;
      background: #fff;
      margin-top: 0.3rem;
      padding-bottom: 0.2rem;
    }
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding: 0 0.2rem;
  }

  .banner {
    img {
      width: 94%;
    }
    background: #fff;
    text-align: center;
    padding: 0.2rem 0;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>

